import { create } from 'zustand'

interface UiStore {
  mobileSidebarOpen: boolean
  openMobileSidebar: () => void
  closeMobileSidebar: () => void
  toggleMobileSidebar: () => void
  // Set while the landing page owns the property selector. The top bar keeps
  // its copy laid out but invisible, so the flying one has a target to measure.
  propertySelectorInFlight: boolean
  setPropertySelectorInFlight: (inFlight: boolean) => void
}

export const useUiStore = create<UiStore>((set) => ({
  mobileSidebarOpen: false,
  openMobileSidebar: () => set({ mobileSidebarOpen: true }),
  closeMobileSidebar: () => set({ mobileSidebarOpen: false }),
  toggleMobileSidebar: () => set((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen })),
  propertySelectorInFlight: false,
  setPropertySelectorInFlight: (inFlight) => set({ propertySelectorInFlight: inFlight }),
}))
